import { useQuery } from '@apollo/client';
// @ts-ignore
import getVehicleOwner from '../../graphql/bos/getVehicleOwner.gql';

/**
 * Custom hook to fetch vehicle owner data.
 * It uses Apollo Client's `useQuery` to execute the GraphQL query to get vehicle owner details.
 *
 * @param {string} vehicleId - The ID of the vehicle.
 * @param {string} [ssn] - The Social Security Number (SSN) of the owner. Optional.
 * @param {boolean} [shouldIgnoreInspectionCheck] - Flag to indicate whether to ignore the inspection check. Optional.
 *
 * @returns {Object} An object containing the loading status, error (if any), fetched data, and a refetch function.
 * @returns {boolean} return.loading - Indicates if the query is in a loading state.
 * @returns {ApolloError | undefined} return.error - Error object if the query failed.
 * @returns {Object | undefined} return.data - Data object containing the fetched vehicle owner details.
 * @returns {Function} return.refetch - Function to manually refetch the query.
 */
export function useVehicleOwner (vehicleId: string, ssn?: string, shouldIgnoreInspectionCheck?: boolean) {
    const params = ssn
        ? { id: vehicleId, ownerSsn: ssn, shouldIgnoreInspectionCheck: shouldIgnoreInspectionCheck }
        : { id: vehicleId, shouldIgnoreInspectionCheck: shouldIgnoreInspectionCheck };

    const { loading, error, data, refetch } = useQuery(getVehicleOwner, {
        variables: { ...params }
    });

    return { loading, error, data, refetch };
}
